import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { LoginService } from "../../services/login.service";
import { PermisosService } from "../../services/permisos.service";
import { NgZone } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { UserRoles } from "../../enums/user-roles.enum";
import { AuthService } from "src/app/services/auth.service";

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "ni-tv-2 text-primary",
    class: "",
  },
  { path: "/icons", title: "Icons", icon: "ni-planet text-blue", class: "" },
  { path: "/maps", title: "Maps", icon: "ni-pin-3 text-orange", class: "" },
  {
    path: "/user-profile",
    title: "User profile",
    icon: "ni-single-02 text-yellow",
    class: "",
  },
  {
    path: "/tables",
    title: "Tables",
    icon: "ni-bullet-list-67 text-red",
    class: "",
  },
  { path: "/login", title: "Login", icon: "ni-key-25 text-info", class: "" },
  {
    path: "/register",
    title: "Register",
    icon: "ni-circle-08 text-pink",
    class: "",
  },
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  public isCollapsed = true;
  user: any;
  isDropdownOpen = false;
  constructor(
    private router: Router,
    private loginService: LoginService,
    // private permisosService: PermisosService,
    public zone: NgZone,
    public authService: AuthService
  ) {}

  async ngOnInit(): Promise<void> {
    this.user = JSON.parse(localStorage.getItem("user"));
    // this.usuarios_ver = await this.permisosService.buscarPermisoValor("usuarios_ver");
    // this.servicios_ver = await this.permisosService.buscarPermisoValor(
    //   "servicios_ver"
    // );
    // this.visitas_ver = await this.permisosService.buscarPermisoValor(
    //   "visitas_ver"
    // );
    // this.clientes_ver = await this.permisosService.buscarPermisoValor(
    //   "clientes_ver"
    // );
    // this.datos_extras_ver = await this.permisosService.buscarPermisoValor(
    //   "datos_extras_ver"
    // );
    // this.direcciones_ver = await this.permisosService.buscarPermisoValor(
    //   "direcciones_ver"
    // );
    // console.log(this);
  }

  toggleMenu() {
    let vut = document.getElementById('navButton');
    vut.click();
  }

  Logout() {
    this.loginService.logout();
  }

  over(drop:NgbDropdown){
    drop.open()
  }
  out(drop:NgbDropdown){
    drop.close()
  }

}
